import { Component, OnInit, HostListener, AfterViewInit, ElementRef,ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalsService } from '../common/services/globals.service';
import { SharedService } from '../common/services/shared.service';
import Stepper from 'bs-stepper';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Payment } from '../common/payment';
import { PaymentPayload, ACHPaymentDetailObj, CCPaymentDetailObj } from '../common/paymentpayload';
import { AdverseNotoficationComponent } from '../adverse-notification/adverse-notification.component';
import { PaymentDetailObj } from '../common/paymentpayload';
declare var $: any
// import { globalAgent } from 'http';

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { prefillHostVars } from '@angular/core/src/render3/instructions';
import { DecimalPipe } from '@angular/common';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {
  date = new Date();
  currentDate = new Date();
  payment: Payment = {};
  paymentForm: FormGroup;
  private stepper: Stepper;
  fieldValidity: Map<string, string> = new Map<string, string>();
  numericReg = /^\d+$/;
  pureAlphaNumericPattern = /^[a-zA-Z0-9 ]*[a-zA-Z ]+[a-zA-Z0-9 ]*$/;
  products: Array<Product> = new Array<Product>()
  //totalAmountDue: number;
  billingAddrIsDifferent: boolean = false;
  paymentDetailObj: PaymentDetailObj = {};
  paymentPayload: PaymentPayload = {};
  paymentSubmitStatus: boolean = false;
  termsAndConditionsRead: boolean = false;
  modalMsg = '';
  simulationParam: boolean = false;
  iframeURL = "/billing/paynow/assets/" + this.partner + "_terms_conditions.pdf";
  submissionAttempts = 0;
  UserType: string;
  agentPaymentAuthorizationIsChecked: boolean = true;
  agentGIACTAuthorizationIsChecked: boolean = true;
  showAdverseNotification: boolean = false;
  adverseDetails: any;
  adverseNotificationStatus: boolean = false;
  failureCount: any;
  redirectURL: string = '';

  @ViewChild('submitButton') public submitButton: ElementRef;
  @ViewChild(AdverseNotoficationComponent)
  child: AdverseNotoficationComponent;

  phoneNum: string;

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    if (( Math.abs(event.target.scrollTop - (event.target.scrollHeight - event.target.offsetHeight))) < (event.target.scrollHeight * 0.5) ) {
      this.termsAndConditionsRead = true;
      console.log('Terms and conditions read in full');
    }
  }

  get partnerEbillLogo() {
    return "/billing/paynow/assets/img/" + GlobalsService.partner + "_EBILL_Logo.png";
  }

  get ModalMsg() {
    return this.modalMsg;
  }

  get productCount() {
    return this.products.length;
  }

  get businessName() {
    return GlobalsService.businessName;
  }

  get TCLink() {
    if (GlobalsService.language == null || GlobalsService.language == '' || GlobalsService.language == 'EN') {
      return "../../../billing/paynow/assets/ePAY_T&C.pdf";
    } else if(GlobalsService.language == 'ES') {
       if(GlobalsService.partner === 'AHNJ') {
        return "../../../billing/paynow/assets/ES_ePAY_T&C.pdf";
      }
    }
  }
  
  constructor(
    private _global: GlobalsService,
    private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    // get the route params
    this.route.queryParams.subscribe(params => {
      this.simulationParam = (params['simulation'] === 'true') ? true : false;
    });

    this.assignProductData();
    this.stepper = new Stepper(document.querySelector('#stepper1'), {
      linear: false,
      animation: true
    });

    this.fieldValidity.set('paymentType', '');
    this.fieldValidity.set('accountHolderFirstName', '');
    this.fieldValidity.set('accountHolderLastName', '');
    this.fieldValidity.set('achType', '');
    this.fieldValidity.set('bankaccountType', '');
    this.fieldValidity.set('businessName', '');
    this.fieldValidity.set('routingNumber', '');
    this.fieldValidity.set('accountNumber', '');
    this.fieldValidity.set('accountNumberConfirmation', '');
    this.fieldValidity.set('cardType', '');
    this.fieldValidity.set('cardNumber', '');
    this.fieldValidity.set('addrLine1', '');
    this.fieldValidity.set('addrLine2', '');
    this.fieldValidity.set('city', '');
    this.fieldValidity.set('state', '');
    this.fieldValidity.set('zip', '');
    this.fieldValidity.set('contactEmailAddress', '');
    this.fieldValidity.set('dateOfBirth', '');

    this.paymentForm = this.formBuilder.group({
      paymentType: ['', Validators.required],
      routingNumber: [''],
      dateOfBirth: [''],
      accountNumber: [''],
      accountNumberConfirmation: [''],
      paymentAmount: [''],
      achType: [''],
      bankaccountType: [''],
      businessName: [''],
      cardNumber: [''],
      accountHolderFirstName: [''],
      accountHolderLastName: [''],
      billingAndPrimaryAddrMatch: [''],
      cardType: [''],
      debitType: [''],
      expMonth: [''],
      expYear: [''],
      addrLine1: [''],
      addrLine2: [''],
      city: [''],
      state: [''],
      zip: [''],
      contactEmailAddress: ['']
    }, {
        validator: this.MustMatch('accountNumber', 'accountNumberConfirmation')
      });

      this.UserType = GlobalsService.saml.UserType;
      this.payment.accountHolderType = 'personal';
  }

  get userTypeAgentMember () {
    return GlobalsService.saml.UserType.toLowerCase();
  }
  toggleBillingAddr() {
    this.billingAddrIsDifferent = !this.billingAddrIsDifferent;
  }

  get partner() {
    return GlobalsService.partner;
  }

  get billingAddrDiffers() {
    return this.billingAddrIsDifferent;
  }

  get suppressCard() {
    if (GlobalsService.saml.SuppressCreditCard.includes('Y')) {
      return true;
    } else {
      return false;
    }
  }

  get memberAddress() {
    return GlobalsService.saml.StreetName1 + ' ' + GlobalsService.saml.StreetName2 + ' - ' +
      GlobalsService.saml.CityName + ', ' + GlobalsService.saml.State + ' ' + GlobalsService.saml.ZipCode;
  }

  get language() {
    return GlobalsService.language;
  }

  get partnerPhone() {
    return GlobalsService.lookupPartnerPhoneNum(GlobalsService.partner);
  }

  /*
  setTotalAmountDue() {
    var totalAmountDue = 0;
    for (let i = 0; i < this.products.length; i++) {
      totalAmountDue += Number(this.products[i].productPrice);
    }
    this.totalAmountDue = totalAmountDue;
    this.payment.paymentAmount = this.totalAmountDue;
  }
  */

  // comment is added here

  get returnURL() {
    return GlobalsService.saml.ReturnURL.split(':')[1];
  }

  get totalAmountOwed() {
    return GlobalsService.saml.PremiumAmountTotal;
  }

  //new method - keep commented for now
  /*
  assignProductData() {
      var productDataArray = GlobalsService.saml.PlanName.split(',');
      if (productDataArray.length < 2 && !(productDataArray[0].includes('-'))) {
        var p = new Product();
        p.productType = productDataArray[0];
        p.productName = productDataArray[1];
        p.productPrice = GlobalsService.saml.PremiumAmountTotal;
        this.products.push(p);
      } else {
        for (let i = 0; i < productDataArray.length; i++) {
          var p = new Product();
          var productDetails = productDataArray[i].split('-');
          p.productType = productDetails[0];
          p.productName = productDetails[1];
          p.productPrice = productDetails[2];
          this.products.push(p);
        }
        this.payment.paymentAmount = Number.parseFloat(GlobalsService.saml.PremiumAmountTotal);
      }
  }
  */

  //old method - keep active for now
  assignProductData() {
    var productDataArray = GlobalsService.saml.PlanName.split(',');
    if (productDataArray.length < 2 && !(productDataArray[0].includes('-'))) {
      var p = new Product();
      p.productName = productDataArray[0];
      p.productPrice = GlobalsService.saml.PremiumAmountTotal;
      p.ProductLineName = GlobalsService.saml.ProductLineName;
      if (p.ProductLineName.toUpperCase().includes('DENTAL')) {
        p.ProductLineName = 'DENTAL';
      }
      this.products.push(p);
    } else {
      for (let i = 0; i < productDataArray.length; i++) {
        var p = new Product();
        var productDetails = productDataArray[i].split('-');
        p.productName = productDetails[0];
        p.productPrice = productDetails[1];
        p.ProductLineName = GlobalsService.saml.ProductLineName;
        if (p.ProductLineName.toUpperCase().includes('DENTAL')) {
          p.ProductLineName = 'DENTAL';
        }
        this.products.push(p);
      }
      this.payment.paymentAmount = Number.parseFloat(GlobalsService.saml.PremiumAmountTotal);
    }
  }

  next() {
    this.stepper.next();
  }

  prev() {
    this.stepper.previous();
    if ($("#consentCheckbox").prop("checked") === false) {
      $("#consentCheckbox").prop("checked", false);
    }
  }

  get f() { return this.paymentForm.controls; }

  backToFirstScreen() {
    $('#paymentModalRetry').modal('hide');
    $('#paymentModalRetryACH').modal('hide');
    this.stepper.reset();
  }

  onSubmit() {
    this.submissionAttempts++;
    // payload to form payment detail object
    if (this.payment.paymentType == 'Bank Account') {
      this.paymentDetailObj = new ACHPaymentDetailObj();
      this.paymentDetailObj.achAcctNum = this.payment.accountNumber;
      this.paymentDetailObj.achRtNum = this.payment.routingNumber;
      this.paymentDetailObj.pmtMthd = 'ACH';
      this.paymentDetailObj.pmtMthdType = (this.payment.achType === 'checking') ? 'DA' : 'SG';
      this.paymentDetailObj.firstNameBankAcct = this.payment.accountHolderFirstName;
      this.paymentDetailObj.lastNameBankAcct = this.payment.accountHolderLastName;
      this.paymentDetailObj.businessNameBankAcct = this.payment.businessNameBankAcct;
      this.paymentDetailObj.accountHolderType = this.payment.accountHolderType;
      this.paymentDetailObj.custEmail = this.payment.contactEmailAddress;
      if (this.payment.accountHolderType === 'personal') {
        this.paymentDetailObj.custDOB = new Date(this.payment.custDOB).toISOString();
      } else {
        this.paymentDetailObj.custDOB = '';
      }
    } else {
      this.paymentDetailObj = new CCPaymentDetailObj();
      this.paymentDetailObj.pmtMthd = 'CC';
      this.paymentDetailObj.dbType = '';
      if (this.payment.paymentType == 'Credit Card') {
        if (this.payment.cardType == 'Visa') {
          this.paymentDetailObj.ccCode = 'VI'; //Need to update once we get the info on pmtMthd
        } else if (this.payment.cardType == 'MasterCard') {
          this.paymentDetailObj.ccCode = 'MC';
        } else if (this.payment.cardType == 'American Express') {
          this.paymentDetailObj.ccCode = 'AX';
        } else if (this.payment.cardType == 'Discover') {
          this.paymentDetailObj.ccCode = 'DI';
        }
      } else if (this.payment.paymentType == 'Debit Card' || this.payment.paymentType == 'Prepaid Debit Card') {
        this.paymentDetailObj.ccCode = 'DB';
        if (this.payment.cardType == 'Visa') {
          this.paymentDetailObj.dbType = 'VI'; //Need to update once we get the info on pmtMthd
        } else if (this.payment.cardType == 'MasterCard') {
          this.paymentDetailObj.dbType = 'MC';
        } else if (this.payment.cardType == 'American Express') {
          this.paymentDetailObj.dbType = 'AX';
        } else if (this.payment.cardType == 'Discover') {
          this.paymentDetailObj.dbType = 'DI';
        }
      }
      this.paymentDetailObj.ccNum = this.payment.cardNumber;
      this.paymentDetailObj.ccExp = this.payment.expMonth + this.payment.expYear;
    }

    if (GlobalsService.saml.PaymentAmount === null || GlobalsService.saml.PaymentAmount === '') {
      this.paymentDetailObj.pmtAmt = GlobalsService.saml.PremiumAmountTotal;
    } else {
      this.paymentDetailObj.pmtAmt = GlobalsService.saml.PaymentAmount;
    }

    this.paymentDetailObj.pmtAmt = Number(this.paymentDetailObj.pmtAmt).toFixed(2);

    //console.log(GlobalsService.saml.PaymentAmount);
    //console.log(GlobalsService.saml.PremiumAmountTotal);
    //console.log(this.paymentDetailObj.pmtAmt);

    // Payload to form payment user object by using saml
    this.paymentPayload.ApplicationID = GlobalsService.saml.ApplicationID;
    if (this.payment.accountHolderType === 'personal') {
      this.paymentPayload.FirstName = this.payment.accountHolderFirstName;
      this.paymentPayload.MiddleName = GlobalsService.saml.MiddleName;
      this.paymentPayload.LastName = this.payment.accountHolderLastName;
    } else {
      this.paymentPayload.FirstName = (this.payment.accountHolderFirstName != '') ? this.payment.accountHolderFirstName : GlobalsService.saml.FirstName;;
      this.paymentPayload.MiddleName = GlobalsService.saml.MiddleName;
      this.paymentPayload.LastName = (this.payment.accountHolderLastName != '') ? this.payment.accountHolderLastName : GlobalsService.saml.LastName;
    }
    
    this.paymentPayload.ContactEmailAddress = GlobalsService.saml.ContactEmailAddress;

    this.paymentPayload.StreetName1 = GlobalsService.saml.StreetName1;
    //console.log(this.paymentPayload.StreetName1);
    this.paymentPayload.StreetName2 = GlobalsService.saml.StreetName2;
    this.paymentPayload.State = GlobalsService.saml.State;
    this.paymentPayload.CityName = GlobalsService.saml.CityName;
    this.paymentPayload.ZipCode = GlobalsService.saml.ZipCode;

    if (this.payment.addrLine1 != null && this.payment.addrLine1 != '') {
      //console.log(this.payment.addrLine1 + "is not null");
      this.paymentPayload.StreetName1 = this.payment.addrLine1;
      this.paymentPayload.StreetName2 = this.payment.addrLine2;
      this.paymentPayload.State = this.payment.state;
      this.paymentPayload.CityName = this.payment.city;
      this.paymentPayload.ZipCode = this.payment.zip;
    }

    if (this.payment.contactEmailAddress != null && this.payment.contactEmailAddress != '') {
      this.paymentPayload.ContactEmailAddress = this.payment.contactEmailAddress;
    }

    this.paymentPayload.payment = this.paymentDetailObj;
    //alert(this.payment);
    //validate and submit
    this.http.post<any>(this.sharedService.getURI('payment'), JSON.stringify(this.paymentPayload)).subscribe(data => {
      this.paymentSubmitStatus = true;
      //console.log(data);
      // redirect to the returnURL once the payment status get success
      if (data.paymentStatus === 'SUCCESS') {
        window.location.href = data.returnURL;
      } else if (data.paymentStatus === 'ERROR') {
        this.submitButton.nativeElement.disabled = false;
        if (GlobalsService.language == 'ES') {
          this.submitButton.nativeElement.innerText = 'Enviar';
        } else {
          this.submitButton.nativeElement.innerText = 'Submit';
        }
        if (String(data.paymentID).startsWith('EPY')) {
          window.location.href = data.returnURL;
        } else if (data.errors[0].code === 'D20') {
          this.modalMsg = "only_accept_ach";
          $('#paymentModalRetryACH').modal({
            backdrop: 'static',
            keyboard: false,
            show: true
          });
          this.clearPaymentDetails();
          GlobalsService.saml.SuppressCreditCard = 'Y';
          this.paymentSubmitStatus = false;
        } else if (data.errors[0].code === 'B13' || data.errors[0].code === 'N14' || data.errors[0].code === 'N15' || data.errors[0].code === 'N16' || data.errors[0].code === 'N18') {
          this.modalMsg = "routing_number_account_number_invalid";
          $('#paymentModalRetryACH').modal({
            backdrop: 'static',
            keyboard: false,
            show: true
          });
          this.clearPaymentDetails();
          this.paymentSubmitStatus = false;
        } else if (data.errors[0].code === 'N26') {
          this.modalMsg = "debiblock_invalid";
          $('#paymentModalRetryACH').modal({
            backdrop: 'static',
            keyboard: false,
            show: true
          });
          this.clearPaymentDetails();
          this.paymentSubmitStatus = false;
        } else {
          $('#paymentModalRetry').modal({
            backdrop: 'static',
            keyboard: false,
            show: true
          });
          this.clearPaymentDetails();
          this.paymentSubmitStatus = false;
        }
      } else if (data.paymentStatus === 'ADVERSE') {
        this.redirectURL = data.returnURL;
        this.failureCount = parseInt(data.failureCount);;
        this.showAdverseNotification = true;
        //this.dataContainer.nativeElement.innerHTML = data.adverseNote;
        this.adverseDetails = { 
          adverseNote: data.adverseNote,
          firstName: this.payment.accountHolderFirstName,
          lastName: this.payment.accountHolderLastName,
          acctName: GlobalsService.saml.FirstName + ' ' + GlobalsService.saml.LastName,
          businessName: this.businessName,
          merchantId: data.merchantId,
          referenceId: data.referenceId,
          productCode: data.productCode,
          memberEmailAddress: (this.payment.contactEmailAddress === undefined) ? '' : this.payment.contactEmailAddress,
          addressLine1: GlobalsService.saml.StreetName1,
          addressLine2: GlobalsService.saml.StreetName2,
          city: GlobalsService.saml.CityName,
          state: GlobalsService.saml.State,
          postalCode: GlobalsService.saml.ZipCode,
          UserType: GlobalsService.saml.UserType,
          partner: this.partner,
          failureCount: this.failureCount,
          language: GlobalsService.saml.Language,
          applicationId: data.applicationId
        };
        this.adverseNotificationStatus = false;
        this.submitButton.nativeElement.disabled = false;
        this.clearPaymentDetails();
        this.paymentSubmitStatus = false;
        window.scroll(0,0);
      } else {
        this.submitButton.nativeElement.disabled = false;
        if (GlobalsService.language == 'ES') {
          this.submitButton.nativeElement.innerText = 'Enviar';
        } else {
          this.submitButton.nativeElement.innerText = 'Submit';
        }
        $('#paymentModalRetry').modal({
          backdrop: 'static',
          keyboard: false,
          show: true
        });
        this.clearPaymentDetails();
        this.paymentSubmitStatus = false;
      }
    },
      (error => {
        this.submitButton.nativeElement.disabled = false;
        if (GlobalsService.language == 'ES') {
          this.submitButton.nativeElement.innerText = 'Enviar';
        } else {
          this.submitButton.nativeElement.innerText = 'Submit';
        }
        $('#paymentModalUnavailable').modal({
          backdrop: 'static',
          keyboard: false,
          show: true
        });
      }));
    //this.http.post<any>('https://wasintertenv6.highmark.com/eblarc/service/binder/payment', JSON.stringify(this.payment), { headers: new HttpHeaders({'Content-Type': 'application/json'}) }).subscribe(data => { })
  }

  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  onKey(event) {
    //Shared fields
    if (event.target.name == 'accountHolderFirstName') {
      if (event.target.value == "" && this.payment.accountHolderType === 'personal') {
        this.fieldValidity.set('accountHolderFirstName', 'required');
      } else if (event.target.value != "" && (event.target.value.length < 3 || event.target.value.length > 40 || !(this.pureAlphaNumericPattern.test(event.target.value)))) {
        this.fieldValidity.set('accountHolderFirstName', 'invalid');
      } else {
        this.fieldValidity.set('accountHolderFirstName', '');
      }
    } else if (event.target.name == 'accountHolderLastName') {
      if (event.target.value == "" && this.payment.accountHolderType === 'personal') {
        this.fieldValidity.set('accountHolderLastName', 'required');
      } else if (event.target.value != "" && (event.target.value.length < 3 || event.target.value.length > 40 || !(this.pureAlphaNumericPattern.test(event.target.value)))) {
        this.fieldValidity.set('accountHolderLastName', 'invalid');
      } else {
        this.fieldValidity.set('accountHolderLastName', '');
      }
        //business name
    } else if (event.target.name == 'businessName') {
      if (event.target.value == "") {
        this.fieldValidity.set('businessName', 'required');
      } else if (event.target.value != "" && (event.target.value.length < 3 || event.target.value.length > 85 || !(this.pureAlphaNumericPattern.test(event.target.value)))) {
        this.fieldValidity.set('businessName', 'invalid');
      } else {
        this.fieldValidity.set('businessName', '');
      }
      //ACH fields
    } else if (event.target.name == 'routingNumber') {
      if (event.target.value == "") {
        this.fieldValidity.set('routingNumber', 'required');
      } else if (event.target.value.length != 9 || !(this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('routingNumber', 'invalid');
      } else {
        this.fieldValidity.set('routingNumber', '');
      }
    } else if (event.target.name == 'accountNumber') {
      if (event.target.value == "") {
        this.fieldValidity.set('accountNumber', 'required');
      } else if (event.target.value.length < 4 || event.target.value.length > 17) {
        this.fieldValidity.set('accountNumber', 'invalid');
      } else if (this.payment.routingNumber === this.payment.accountNumber) {
        this.fieldValidity.set('accountNumber', 'mustdifferent');
      } else {
        this.fieldValidity.set('accountNumber', '');
      }
    } else if (event.target.name == 'accountNumberConfirmation') {
      if (event.target.value == "") {
        this.fieldValidity.set('accountNumberConfirmation', 'required');
      } else if (event.target.value != this.payment.accountNumber.valueOf()) {
        this.fieldValidity.set('accountNumberConfirmation', 'invalid');
      } else {
        this.fieldValidity.set('accountNumberConfirmation', '');
      }
    }
    //CCDC fields
    else if (event.target.name == 'cardNumber') {
      if (event.target.value == "") {
        this.fieldValidity.set('cardNumber', 'required');
      } else if (this.payment.cardType == "American Express"){
        if(event.target.value.length != 15 || !(this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('cardNumber', 'invalid');}
        else{
          this.fieldValidity.set('cardNumber', '');}
      } else if (event.target.value.length != 16 || !(this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('cardNumber', 'invalid');
      } else {
        this.fieldValidity.set('cardNumber', '');
      }
    } else if (event.target.name == 'addrLine1') {
      if (event.target.value == "") {
        this.fieldValidity.set('addrLine1', 'required');
      } else if (event.target.value.length < 5) {
        this.fieldValidity.set('addrLine1', 'invalid');
      } else {
        this.fieldValidity.set('addrLine1', '');
      }
    } else if (event.target.name == 'city') {
      if (event.target.value == "") {
        this.fieldValidity.set('city', 'required');
      } else if (event.target.value.length < 2 || (this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('city', 'invalid');
      } else {
        this.fieldValidity.set('city', '');
      }
    } else if (event.target.name == 'zip') {
      if (event.target.value == "") {
        this.fieldValidity.set('zip', 'required');
      } else if (event.target.value.length != 5 || !(this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('zip', 'invalid');
      } else {
        this.fieldValidity.set('zip', '');
      }
    } else if (event.target.name == 'contactEmailAddress') {
      if (event.target.value == "") {
        this.fieldValidity.set('contactEmailAddress', 'required');
      } else if (!event.target.value.match('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')) {
        this.fieldValidity.set('contactEmailAddress', 'invalid');
      } else {
        this.fieldValidity.set('contactEmailAddress', '');
      }  
    }
    else if (event.target.name == 'dateOfBirth') {
      this.isValidDate(event.target.value);
      if (event.target.value == "") {
        this.fieldValidity.set('dateOfBirth', 'required');
      } else if (!this.isValidDate(event.target.value)) {
        this.fieldValidity.set('dateOfBirth', 'invalid');
      } else {
        this.fieldValidity.set('dateOfBirth', '');
      }
    }
  }

  isValidDate(strDate) {
    const dateValidationRegex = /^(0?[1-9]|1[0-2])[\/](0?[1-9]|[1-2][0-9]|3[01])[\/]\d{4}/;
    const dateValidationRegexone = /^\d{4}[\-](0?[1-9]|1[0-2])[\-](0?[1-9]|[1-2][0-9]|3[01])$/;
    if (!dateValidationRegex.test(strDate) && !dateValidationRegexone.test(strDate)) {
      return false;
    } else {
      return true;
    }
  }

  updateDate(event: any) {
    this.date = event.target.valueAsDate;
  }

  expDateInvalid() {
    var d = new Date();
    var currentMonth = d.getMonth() + 1;
    var currentYear = d.getFullYear();
    if ((Number(this.payment.expYear) + 2000) > currentYear) {
      return false;
    } else if (Number(this.payment.expMonth) >= currentMonth) {
      return false;
    } else {
      return true;
    }
  }

  clearPaymentDetails() {
    this.payment.paymentType = '';
    this.payment.routingNumber = '';
    this.payment.accountNumber = '';
    this.payment.accountNumberConfirmation = '';
    this.payment.paymentAmount = 0;
    this.payment.achType = '';
    this.payment.cardNumber = '';
    this.payment.accountHolderFirstName = '';
    this.payment.accountHolderLastName = '';
    this.payment.addrLine1 = '';
    this.payment.addrLine2 = '';
    this.payment.city = '';
    this.payment.state = '';
    this.payment.zip = '';
    this.payment.cardType = '';
    this.payment.expMonth = '';
    this.payment.expYear = '';
    this.payment.custDOB = '';
    this.payment.custEmail = '';
    this.payment.firstNameBankAcct = '';
    this.payment.lastNameBankAcct = '';
    this.payment.businessNameBankAcct = '';
    this.payment.accountHolderType = 'personal';
  }

  // send back the user to GWC
  returnToShopping() {
    this.modalMsg = "confirm_return_to_shopping";
    $('#paymentModalConfirmReturn').modal({
      backdrop: 'static',
      keyboard: false,
      show: true
    });
  }

  returnToShoppingConfirm() {
    history.go(-1);
  }

  returnToShoppingNevermind() {
    $('#paymentModalConfirmReturn').modal('hide');
  }

  get fetchTermsPDFURL() {
    return "/billing/paynow/assets/" + GlobalsService.partner + "_terms_conditions.pdf";
  }

  toggleEmailBillingAddr(authorizationtype) {
    if (authorizationtype === 'PaymentAuthorization') {
      this.agentPaymentAuthorizationIsChecked = !this.agentPaymentAuthorizationIsChecked;
    } else if (authorizationtype === 'GIACTAuthorization') {
      this.agentGIACTAuthorizationIsChecked = !this.agentGIACTAuthorizationIsChecked
    }
    
  }

  printAdverse(): void {
      this.child.printAdverse('print-section');
  }

  adverseDataEventEmitter(adverseNotificationStatus){
    this.adverseNotificationStatus = adverseNotificationStatus;
  }

  reSubmitPayment(reSubmitPaymentStatus){
    if (reSubmitPaymentStatus === true && this.failureCount < 3) {
      this.showAdverseNotification = false;
      this.backToFirstScreen();
    } else if (reSubmitPaymentStatus === true && this.failureCount >= 3) {
      window.location.href = this.redirectURL;
    }
  }

  bankaccountTypeSelect(event) {
    if (event === 'personal' ||  event === 'business')
    this.payment.accountHolderFirstName = '';
    this.payment.accountHolderLastName = '';  
    this.payment.businessNameBankAcct = '';
  }

  // closeAdverse() {
  //   this.showAdverseNotification = false;
  //   this.backToFirstScreen();
  // }

  // closeAdverse() {
  //   this.showAdverseNotification = false;
  //   if (this.failureCount === '3') {
  //     window.location.href = this.redirectURL;
  //   } else {
  //     this.backToFirstScreen();
  //   }
  // }

  closeAdverse() {
    this.showAdverseNotification = false;
    if (this.failureCount >= 3) {
      window.location.href = this.redirectURL;
    } else {
      this.backToFirstScreen();
    }
  }

}

export class Product {
  ProductLineName: string;
  productName: string;
  productPrice: string;
}